export default "__VITE_ASSET__xHIryKmJ__"